import { services } from '../../application/service/services';
import {FeedbackExternalErrorReportDTO, PaginatedResult, SourcingError} from "../model";
import { SearchQuery } from "../../utils/query/SearchQuery";

export class SourcingErrorService {
  _sourcingErrorFetcher;

  init() {
    this._sourcingErrorFetcher = services.getFetcherService().getFetcher('sourcingError');
  }

  isAuthorized(): boolean {
    return services.getSecurityService().hasRole('vecko.sourcing.errors');
  }

  async getErrors(searchQuery: SearchQuery): Promise<PaginatedResult<SourcingError>> {
    return this._sourcingErrorFetcher.getErrors(searchQuery);
  }

  async replay(searchQuery: SearchQuery): Promise<Array<FeedbackExternalErrorReportDTO>> {
    return this._sourcingErrorFetcher.replay(searchQuery);
  }
  async relaunch(searchQuery: SearchQuery): Promise<Array<FeedbackExternalErrorReportDTO>> {
    return this._sourcingErrorFetcher.relaunch(searchQuery);
  }

  async deleteErrors(searchQuery: SearchQuery): Promise<void> {
    return this._sourcingErrorFetcher.deleteErrors(searchQuery);
  }

  getValues(column: string) {
    return this._sourcingErrorFetcher.getValues(column);
  }
}

services.registerService('sourcingErrorService', new SourcingErrorService());